import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import {
  Launch as ExternalLinkIcon,
  Visibility as EyeIcon,
  Email as MailIcon,
  Message as MessageIcon,
  Refresh as RefreshIcon,
  Send as SendIcon
} from '@material-ui/icons';

const useVariantStyles = makeStyles({
  base: {
    fontWeight: 500,
    borderRadius: 24,
    textTransform: 'none',
    padding: '12px',
    width: 193,
    fontSize: 14,
    lineHeight: 1.25,
    transition: 'all 0.3s ease',
    border: 'none',
    '& svg': {
      verticalAlign: 'middle'
    }
  },
  primary: {
    backgroundColor: '#ffd83c',
    color: 'white',
    '&:hover': {
      backgroundColor: '#ffd83ce6',
      color: 'white'
    }
  }
});

function CTAButton({
  label,
  onClick,
  className,
  children,
  variant,
  icon,
  secondary,
  backgroundColor,
  style
}) {
  const variantClasses = useVariantStyles();

  const iconMap = {
    link: <ExternalLinkIcon style={{ fontSize: 16 }} />,
    eye: <EyeIcon style={{ fontSize: 16 }} />,
    mail: <MailIcon style={{ fontSize: 16 }} />,
    message: <MessageIcon style={{ fontSize: 16 }} />,
    refresh: <RefreshIcon style={{ fontSize: 16 }} />,
    send: <SendIcon style={{ fontSize: 16 }} />
  };

  if (!label && !children) return null;

  const combinedClasses = variant
    ? [variantClasses.base, variantClasses[variant], className]
    : [variantClasses.base, className];

  const buttonStyle = {
    ...style,
    ...(backgroundColor && {
      backgroundColor,
      color: 'white',
      '&:hover': {
        backgroundColor: `${backgroundColor}dd`,
        color: 'white'
      }
    })
  };

  const iconElement = icon && iconMap[icon];
  const iconWithMargin = iconElement && React.cloneElement(iconElement, {
    style: {
      ...iconElement.props.style,
      ...(secondary ? { marginLeft: 8 } : { marginRight: 8 }),
      ...(backgroundColor && { color: 'white' })
    }
  });

  return (
    <Button
      style={buttonStyle}
      onClick={onClick}
      className={combinedClasses.filter(Boolean).join(' ')}
    >
      {!secondary && iconWithMargin}
      {label || children}
      {secondary && iconWithMargin}
    </Button>
  );
}

CTAButton.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node,
  variant: PropTypes.oneOf(['primary']),
  icon: PropTypes.oneOf(['link', 'eye', 'mail', 'message', 'refresh', 'send']),
  secondary: PropTypes.bool,
  backgroundColor: PropTypes.string,
  style: PropTypes.object
};

CTAButton.defaultProps = {
  label: undefined,
  onClick: undefined,
  className: undefined,
  children: undefined,
  variant: undefined,
  icon: null,
  secondary: false,
  backgroundColor: null,
  style: {}
};

export default CTAButton;
